import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingGrid from "./components/LandingInfo/LandingGrid";
import Works from "./components/LandingInfo/Works";
import WorkDetail from "./components/LandingInfo/WorkDetail";
import AboutPage from "./components/LandingInfo/AboutPage";
import ContactPage from "./components/LandingInfo/ContactPage";
import AdminApp from "./components/Admin/AdminApp";
import { Box } from "@mui/system";

function Browser() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingGrid />} />
        <Route path="/admin" element={<AdminApp />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/works/:category/:workId" element={<WorkDetail />} />
        <Route
          path="/works"
          element={
            <Box position={"relative"}>
              <Works />
            </Box>
          }
        />
        <Route path="*" element={<LandingGrid />} />
      </Routes>
    </Router>
  );
}

export default Browser;
